// extracted by mini-css-extract-plugin
export default {"title":"PopularBreeder_title__Gn0WX","row":"PopularBreeder_row__nYNjp","loadMoreButton":"PopularBreeder_loadMoreButton__BPlYL","grayArea":"PopularBreeder_grayArea__DtZ2w"};